import { Button, Row } from 'antd';
import React, { useEffect, useMemo } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IStateDepartment } from 'src/entity/StateEntity';
import { fetchDepartmentsIfNeeded } from 'src/redux/actions/departmentCreator';
import { RouterConfig } from 'src/routers/urlConfig';
import DepartmentAdminService from 'src/services/DepartmentAdminService';
import I18N from 'src/services/I18NService';
import DepartmentUserForm from './User/UserForm';

interface IProps extends RouteComponentProps<{uuid: string | undefined}>  {
  departmentState: IStateDepartment,
  dispatch: Dispatch<IStateDepartment>
}

const DepartmentAdminDetailPage: React.FC<IProps> = (props) => {
  const {
    departmentState,
    match,
    location,
    history,
    dispatch,
  } = props;
  const {params} = match;
  const {search} = location;
  const { list } = departmentState;

  const userUuid = params.uuid;
  const searchParams = new URLSearchParams(search);
  const departmentId = searchParams.get('department');

  const formStatus = userUuid ? 'edit' : 'add';
  let title = formStatus === 'add' ? 'nav_userAdmin_add' : 'nav_userAdmin_edit'
  title = I18N.get(title);

  const treeData = useMemo(() => DepartmentAdminService.buildDepartmentTreeData(list || []), [list]);

  useEffect(() => {
    dispatch(fetchDepartmentsIfNeeded());
  }, []);

  const handleGoback = () => {
    history.push({
      pathname: `${RouterConfig.Urls.departmentAdmin}`,
      state: {useCache: true}, // 查询条件使用缓存
    });
  }

  return (
    <section style={{padding: '0 36px'}}>
      <Row type="flex" align="middle" justify="space-between" style={{marginBottom: 16}}>
        <span style={{fontSize: 16, color: '#1fb8cd'}}>{title}</span>
        <Button type="primary" onClick={handleGoback}>
          {I18N.get('common_back')}
        </Button>
      </Row>
      <DepartmentUserForm
        formStatus={formStatus}
        departmentTree={treeData}
        user={userUuid}
        departmentId={departmentId}
        onFinished={handleGoback}
      />
    </section>
  )
};

export default DepartmentAdminDetailPage;






// WEBPACK FOOTER //
// ./src/components/views/DepartmentAdmin/DepartmentAdminDetailPage.tsx